import { render, staticRenderFns } from "./ClearNotificationBlockedUsersPopup.vue?vue&type=template&id=61ebe48b&scoped=true&"
import script from "./ClearNotificationBlockedUsersPopup.vue?vue&type=script&lang=ts&"
export * from "./ClearNotificationBlockedUsersPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ClearNotificationBlockedUsersPopup.vue?vue&type=style&index=0&id=61ebe48b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ebe48b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61ebe48b')) {
      api.createRecord('61ebe48b', component.options)
    } else {
      api.reload('61ebe48b', component.options)
    }
    module.hot.accept("./ClearNotificationBlockedUsersPopup.vue?vue&type=template&id=61ebe48b&scoped=true&", function () {
      api.rerender('61ebe48b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/ClearNotificationBlockedUsersPopup.vue"
export default component.exports